import axios from 'axios';

// Set the base URL for all API requests
const API_BASE_URL = 'https://payroll-backend-neon.vercel.app';

// const API_BASE_URL = 'http://localhost:7000';

axios.defaults.baseURL = API_BASE_URL;

export default axios;